import React from 'react';
import { PageHeader } from './PageHeader';
import { Reveal } from '../ui/Reveal';
export interface LegalBlock {
  type: 'p' | 'list';
  text?: string;
  items?: string[];
}
export interface LegalSection {
  heading: string;
  blocks: LegalBlock[];
}
interface LegalLayoutProps {
  title: string;
  subtitle: string;
  updated: string;
  intro?: string;
  sections: LegalSection[];
}
export const LegalLayout = ({
  title,
  subtitle,
  updated,
  intro,
  sections
}: LegalLayoutProps) => {
  return <>
      <PageHeader eyebrow="Legal" title={title} subtitle={subtitle} data-id="element-1445" data-mp="sfm5gjvoe7wa" />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 -mt-4" data-id="element-1446" data-mp="efkta89yne1i">
        <Reveal data-id="element-1447" data-mp="ehnttm8qopkh">
          <p className="text-xs font-semibold uppercase tracking-wider text-zano-pink mb-8" data-id="element-1448" data-mp="jenzvx5l9sbl">
            Updated {updated}
          </p>

          {intro && <p className="text-gray-600 leading-relaxed mb-10" data-id="element-1449" data-mp="28u5844blofcz">{intro}</p>}

          <div className="space-y-10" data-id="element-1450" data-mp="2drdu6fzvd3ji">
            {sections.map((section, i) => <div key={i} data-id="element-1451" data-mp="ohlzxwl3l6o7" data-mpi={i}>
                <h2 className="text-lg font-bold text-zano-charcoal mb-3" data-id="element-1452" data-mp="ogu8mxyj9v3q">
                  {i + 1}. {section.heading}
                </h2>
                <div className="space-y-3" data-id="element-1453" data-mp="y7xd89qo8s7r">
                  {section.blocks.map((block, j) => block.type === 'list' ? <ul key={j} className="list-disc pl-5 space-y-2 text-gray-600 leading-relaxed" data-id="element-1454" data-mp="taf3wi8qsaz8">
                        {block.items?.map((item, k) => <li key={k} data-id="element-1455" data-mp="1kajijkzfny0">{item}</li>)}
                      </ul> : <p key={j} className="text-gray-600 leading-relaxed" data-id="element-1456" data-mp="ai31jvi399p3">
                        {block.text}
                      </p>)}
                </div>
              </div>)}
          </div>
        </Reveal>
      </section>
    </>;
};